// 마이페이지 좌측 메뉴 구성. ready가 false인 메뉴는 '준비 중' 화면으로 연결된다.
// 새 기능을 추가할 때는 이 목록에 항목을 넣고 App.js의 mypage 하위 라우트를 연결한다.
export const myPageMenu = [
    { group: '내 정보', items: [
        { path: 'profile', label: '기본 정보', ready: true },
        { path: 'account', label: '계정·보안', ready: true },
    ] },
    { group: '활동', items: [
        { path: 'activity', label: 'AI 내담자 활동 이력', ready: true },
        { path: 'reflection', label: '반영 연습 이력', ready: false, description: '반영 연습 기록과 피드백을 이곳에서 모아볼 수 있도록 준비하고 있습니다.' },
    ] },
    { group: '이용 관리', items: [
        { path: 'lectures', label: '강의 신청·결제 내역', ready: false, description: '신청한 강의와 결제·환불 내역을 확인할 수 있도록 준비하고 있습니다.' },
        // { path: 'subscription', label: '이용권·멤버십', ready: false, description: 'AI 내담자 이용권과 멤버십 정보를 확인할 수 있도록 준비하고 있습니다.' },
        { path: 'notifications', label: '알림 설정', ready: false, description: '이메일·서비스 알림 수신 여부를 설정할 수 있도록 준비하고 있습니다.' },
    ] },
    { group: '고객 지원', items: [
        { path: 'inquiry-new', label: '문의 등록하기', ready: true },
        { path: 'inquiry', label: '문의 조회하기', ready: true },
    ] },
];

// 경로에 해당하는 메뉴 항목을 찾는다.
export function findMenuItem(path) {
    return myPageMenu.flatMap(group => group.items).find(item => item.path === path);
}
